import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { convertLegacyRouteRef } from '@backstage/core-compat-api';
import { exploreRouteRef } from '@backstage-community/plugin-explore';

/**
 * Override the explore plugin's page with a custom layout that uses
 * Content + RoutedTabs instead of ExploreLayout (which renders a
 * legacy Page + Header).
 */
const explorePage = PageBlueprint.make({
  name: 'explore',
  params: {
    path: '/explore',
    title: 'Explore',
    routeRef: convertLegacyRouteRef(exploreRouteRef),
    loader: () =>
      import('../../components/explore/ExplorePage').then(m => (
        <m.ExplorePage />
      )),
  },
});

export const explorePageModule = createFrontendModule({
  pluginId: 'explore',
  extensions: [explorePage],
});
